import { environment } from '@view-app/environment'

export function jwtOptionsFactory() {
  let worklflowDomain = new URL(environment.workflowHost).host

  return {
    tokenGetter: () => localStorage.getItem(environment.tokenLocalStorageKey),
    allowedDomains: [ worklflowDomain ],
    skipWhenExpired: true
  }
}
